import React, { useEffect, useState } from 'react';
import { ContainerForm } from '../../../components/Containers';
import HeaderTitle from '../../../components/HeaderTitle';
import ButtonBack from '../../../components/ButtonBack';
import { WrapperInputs } from '../../../components/SincronizaNFe/WrapperInputs';
import { useDispatch, useSelector } from 'react-redux';
import { SearchProjectByMonthAction } from '../../../redux/actions/project';
import { MessageBoxAlert } from '../../../components/MessageBox';
import TableConsultBillingsMonth from '../../../components/SincronizaNFe/TableConsultBillingsMonth';
import InputSearch from '../../../components/InputSearch';
import InputMonth from '../../../components/SincronizaNFe/InputMonthSincroniza';

export default function TemplateConsultBillingsMonth() {
  const {
    searchProjectByMonth,
    error: errorSearchProjectByMonth,
    loading: loadingSearchProjectByMonth,
  } = useSelector((state) => state.searchProjectByMonth);
  const dispatch = useDispatch();
  const [searchUser, setSearchUser] = useState('');
  const [month, setMonth] = useState('');
  useEffect(() => {
    const monthNames = [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ];
    const date = new Date();
    const thisMonth = monthNames[date.getMonth()];
    setMonth(thisMonth);
  }, []);

  const filteredUsers = searchUser
    ? searchProjectByMonth.filter((user) => {
        return user.user.name.toLowerCase().includes(searchUser.toLowerCase());
      })
    : searchProjectByMonth;

  useEffect(() => {
    if (errorSearchProjectByMonth === 'Token inválido') {
      localStorage.removeItem('userInfo');
      document.location.href = '/login';
    }
  }, [errorSearchProjectByMonth]);

  useEffect(() => {
    dispatch(SearchProjectByMonthAction(month));
  }, [dispatch, month]);

  return (
    <ContainerForm>
      <HeaderTitle text={`Lista de Faturamentos - ${month}`} linkIcon="/images/icons/list.svg" />
      <WrapperInputs>
        <ButtonBack />
        <InputMonth onChange={(e) => setMonth(e.target.value)} value={month} />
      </WrapperInputs>
      {searchProjectByMonth && searchProjectByMonth.length > 0 && (
        <InputSearch placeholder="Digite o nome do usuário para acha-lo" state={searchUser} setState={setSearchUser} />
      )}
      <TableConsultBillingsMonth searchProjectByMonth={filteredUsers} />
      {loadingSearchProjectByMonth && <MessageBoxAlert>Carregando...</MessageBoxAlert>}
    </ContainerForm>
  );
}
